import React, { useState } from 'react';
import { registerTeacher } from '../../services/api'; // Fixed import path
import Alert from '../common/Alert';
import '../common/RegistrationForm.css';

const TeacherRegistration = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    type: '',
    institutionName: '',
    aadhar: '',
    panCard: ''
  });
  const [alert, setAlert] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await registerTeacher(formData);
      setAlert({
        type: 'success',
        message: `Registration successful! Your referral code is ${response.data.referralCode}`
      });
      setFormData({
        name: '',
        email: '',
        phone: '',
        type: '',
        institutionName: '',
        aadhar: '',
        panCard: ''
      });
    } catch (error) {
      setAlert({
        type: 'error',
        message: error.response?.data?.message || 'Registration failed'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="registration-container">
      <div className="registration-form-wrapper">
        <img
          src="/assets/BigLogo.png"
          alt="Educatory Logo"
          className="educatory-logo"
        />
        <h2>Referral Registration Program</h2>
        <p className="subtitle">Join our network and earn through referrals</p>

        {alert && (
          <Alert
            message={alert.message}
            type={alert.type}
            onClose={() => setAlert(null)}
          />
        )}

        <form onSubmit={handleSubmit} className="registration-form">
          <div className="form-row">
            <div className="form-group">
              <label>Full Name *</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                placeholder="Enter your full name"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                placeholder="Enter your email address"
              />
            </div>

            <div className="form-group">
              <label>Phone *</label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                required
                pattern="[0-9]{10}"
                placeholder="Enter 10-digit phone number"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Role *</label>
              {formData.type === 'Teacher' || formData.type === 'Principal' || formData.type === 'School Owner' || formData.type === 'Alumni / Former Student of Alok Bhaiya' || formData.type === '' ? (
                <select
                  value={formData.type}
                  onChange={(e) => {
                    if (e.target.value === 'Other') {
                      setFormData({ ...formData, type: 'Other ' }); // temp flag to switch to input
                    } else {
                      setFormData({ ...formData, type: e.target.value });
                    }
                  }}
                  required
                >
                  <option value="">Select your role</option>
                  <option value="Teacher">Teacher</option>
                  <option value="Principal">Principal</option>
                  <option value="School Owner">School Owner</option>
                  <option value="Alumni / Former Student of Alok Bhaiya">Alumni / Former Student of Alok Bhaiya</option>
                  <option value="Other">Other</option>
                </select>
              ) : (
                <div style={{ display: 'flex', gap: '8px' }}>
                  <input
                    type="text"
                    value={formData.type === 'Other ' ? '' : formData.type}
                    onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                    required
                    placeholder="Type your role here..."
                    autoFocus
                    style={{ flex: 1 }}
                  />
                  <button
                    type="button"
                    onClick={() => setFormData({ ...formData, type: '' })}
                    style={{ padding: '0 12px', background: '#f1f5f9', border: '1px solid #cbd5e1', borderRadius: '4px', cursor: 'pointer', color: '#475569', fontWeight: 'bold' }}
                    title="Clear and select from list"
                  >
                    ✕
                  </button>
                </div>
              )}
            </div>

            <div className="form-group">
              <label>Institution/Organization Name</label>
              <input
                type="text"
                value={formData.institutionName}
                onChange={(e) => setFormData({ ...formData, institutionName: e.target.value })}
                required
                placeholder="Enter institution name"
              />
            </div>
          </div>

          <div className="form-info-message">
            <small style={{ color: '#64748b', fontStyle: 'italic', display: 'block', marginBottom: '8px' }}>
              * As cash transfers would be involved for the commission payouts, we request your Aadhar and PAN details.
            </small>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Aadhar Number</label>
              <input
                type="text"
                value={formData.aadhar}
                onChange={(e) => setFormData({ ...formData, aadhar: e.target.value })}
                placeholder="Enter 12-digit Aadhar"
                pattern="[0-9]{12}"
              />
            </div>

            <div className="form-group">
              <label>PAN Card</label>
              <input
                type="text"
                value={formData.panCard}
                onChange={(e) => setFormData({ ...formData, panCard: e.target.value.toUpperCase() })}
                placeholder="Enter PAN Number"
                pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
              />
            </div>
          </div>

          <button
            type="submit"
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Processing...' : 'Register & Get Referral Code'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default TeacherRegistration;
